"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlWrapper = exports.messagesMap = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var Locale_1 = require("./Locale");
var utils_1 = require("./TranslationsCustomizationProvider/utils");
var en_US_json_1 = tslib_1.__importDefault(require("./bundles/en-US.json"));
var de_DE_json_1 = tslib_1.__importDefault(require("./bundles/de-DE.json"));
var es_ES_json_1 = tslib_1.__importDefault(require("./bundles/es-ES.json"));
var fr_FR_json_1 = tslib_1.__importDefault(require("./bundles/fr-FR.json"));
var ja_JP_json_1 = tslib_1.__importDefault(require("./bundles/ja-JP.json"));
var nl_NL_json_1 = tslib_1.__importDefault(require("./bundles/nl-NL.json"));
var pt_BR_json_1 = tslib_1.__importDefault(require("./bundles/pt-BR.json"));
var pt_PT_json_1 = tslib_1.__importDefault(require("./bundles/pt-PT.json"));
var zh_Hans_json_1 = tslib_1.__importDefault(require("./bundles/zh-Hans.json"));
var ru_RU_json_1 = tslib_1.__importDefault(require("./bundles/ru-RU.json"));
/**
 * @internal
 */
exports.messagesMap = {
    "en-US": util_1.translationUtils.removeMetadata(en_US_json_1.default),
    "de-DE": de_DE_json_1.default,
    "es-ES": es_ES_json_1.default,
    "fr-FR": fr_FR_json_1.default,
    "ja-JP": ja_JP_json_1.default,
    "nl-NL": nl_NL_json_1.default,
    "pt-BR": pt_BR_json_1.default,
    "pt-PT": pt_PT_json_1.default,
    "zh-Hans": zh_Hans_json_1.default,
    "ru-RU": ru_RU_json_1.default,
};
/**
 * @internal
 */
exports.IntlWrapper = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? Locale_1.DefaultLocale : _b, children = _a.children;
    /**
     * Because of issues described in the ticket FET-855, we decided to use this workaround.
     * After the issues that are described in the ticket are solved or at least reduced,
     * this workaround can be removed.
     */
    var settings = window.gdSettings;
    var messages = react_1.useMemo(function () { return utils_1.pickCorrectWording(exports.messagesMap[locale], settings); }, [locale, settings, exports.messagesMap]);
    return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages }, children));
};
//# sourceMappingURL=IntlWrapper.js.map